require('./register.less');

var pageConfig = window.pageConfig;
var ajax = require('@enhancer/fe-util-ajax');
var locale = require('i18n');
var register = require('./register.html');
var app = require('../../app/app');
var util = require('../../app/util');
var captchaTip =  require('./captcha.html');
var validateObj = null;

if (window.innerHeight < 700) {
  $('body').addClass('small-height')
}

function init () {
  var domain = `${location.hostname.replace(/^[^.]+\./, '')}`;
  var html = register({
    locale: locale(),
    termsUrl: `//${domain}/terms`,
    privacyUrl: `//${domain}/privacy`,
  });

  $('.user-center-wrapper').append(html);

  // 如果后端输出错误了 页面上就有#error元素 
  //$('#error').css('display', 'block');

  var accountCache = {};
  var loading = false;

  function checkUserNameExist (account, cb) {
    var type = $('#register-type').val();
    var cacheType = account + type;
    if (accountCache[cacheType]) {
      cb(null, accountCache[cacheType]);
    } else {
      if (loading) {
        return
      }
      loading = true;
      ajax({
        type: 'GET',
        url:  '/api/exist/' + account + '?type=' + type,
        dataType: 'json'
      }, function (res) {
        loading = false;
        if (res.success) {
          if (res.exist) {
            accountCache[cacheType] = 2;
          } else {
            accountCache[cacheType] = 1;
          }
          cb(null, accountCache[cacheType]);
        } else {
          util.show(res.message);
          console.log(res);
        }
      }, function (err) {
        loading = false;
        cb(err);
      });
    }
  }
  function checkUserName (ele, next) {
    var isEmail = $('#register-type').val() === 'email';

    var val = ele.val().trim();
    if (isEmail && util.isEmail(val) || !isEmail && util.isMobile(val)) {
      checkUserNameExist(val, function(err, type) {
        if (err) {
          console.log(err);
          return;
        }
        if (type == 1) {
          ele.removeClass('error');
          next && next();
        } else {
          ele.next('label').text(locale('userExists'));
          ele.addClass('error');
        }
      });
    } else {
      ele.next('label').text(locale(isEmail ? 'emailInvalid' : 'mobileInvalid'));
      ele.addClass('error');
    }
  }

  function checkPassword (ele, next) {
    var val = ele.val().trim();
    if (util.isPassword(val)) {
      ele.removeClass('error');
      next && next();
    } else {
      ele.next('label').text(locale('passwordLength'));
      ele.addClass('error');
    }
  }
  function checkCaptcha(ele, next) {
    var isMobile = $('#register-type').val() === 'mobile';
    if (isMobile) {
      next && next();
      return
    }

    if ($('#captcha').height() < 30) {
      window.onerror('geetest' + Date.now(), $('#account').val() || 'register', 0, 0);
      window.handleEnhancerError({
        stack: 'https://api.geetest.com'
      });
    }

    

    var data = validateObj.getValidate()

    if (data) {
      ele.removeClass('error');
      next && next(data);
    } else {
      ele.next('label').text(locale('captchaEmpty'));
      ele.addClass('error');
    }
  }

  function checkCode(ele, next) { // inviteCode
    var code = ele.val().trim().toUpperCase();
    if (!code ||  code.length == 5 && code.match(/^[A-Z]+$/)) {
      next && next();
    } else {
      ele.next('label').text(locale('inviteCodeInvalid'))
      ele.addClass('error');
    }
  }

  function checkMobileCode(ele, next) {
    var isEmail = $('#register-type').val() === 'email';
    if (isEmail) {
      next && next();
      return
    }

    var code = ele.val().trim();

    if ($('#account').hasClass('error') && code) {
      return;
    };

    if (util.isActiveCode(code)) {
      next && next();
    } else {
      ele.next('label').text(locale('mobileCodeInvalid'))
      ele.addClass('error');
    }
  }

  var checkTimer;
  var interval = 500;
  $('#account').blur( function () {
    checkTimer = setTimeout(() => {
      checkUserName($(this));
    }, interval);
  }).focus(function () {
    $(this).removeClass('error');
  });
  $('#password').blur( function () {
    checkTimer = setTimeout(() => {
      checkPassword($(this));
    }, interval);
  }).focus(function () {
    $(this).removeClass('error');
  });
  $('#invite').blur( function () {
    checkTimer = setTimeout(() => {
      checkCode($(this));
    }, interval);
  }).focus(function () {
    $(this).removeClass('error');
  });
  $('#mobile-code').blur(function () {
    checkTimer = setTimeout(() => {
      checkMobileCode($(this));
    }, interval);
  }).focus(function () {
    $(this).removeClass('error');
  });

  var submitting = false;
  $('.register-form button[type=submit]').click( function (e) {
    e.preventDefault();
    
    checkUserName($('#account'), function () {
      checkPassword($('#password'), function () {
        checkCode($('#invite'), function () {
          checkMobileCode($('#mobile-code'), function () {
            checkCaptcha($('#captcha'), function (data) {
              if (submitting) {
                return;
              }
              submitting = true;
              $('.register-form').submit();
            });
          });
        });
      });
    });
  });

  function switchType (ele) {
    var type = $('#register-type').val();
    clearTimeout(checkTimer);
    if (type === 'mobile') {
      $(ele).text(locale('registerWithMobile'))
      $('#register-type').val('email');
      $('#account').prop('placeholder', locale('email'));
      $('#captcha').show();
    } else {
      $(ele).text(locale('registerWithEmail'));
      $('#register-type').val('mobile');
      $('#account').prop('placeholder', locale('mobile'));
      $('#captcha').hide();
    }
    
    $('#account, #password, #captcha, #mobile-code').removeClass('error')
    $('#account').focus().select();
    $('.mobile-code').toggleClass('hide');
    $('.errortip').hide();
  }
  /*
  $('.register-type-btn a').click(function (e) {
    e.preventDefault();
    var me = this;
    if (!window.EnhancerCaptcha) {
      if ($(me).data('clicking')) {
        return
      }
      $(me).data('clicking', true);
      util.getScript(`//assets.${domain}/vendor/geetest/all/gt.js?v=1`, function () {
        validateObj = new window.EnhancerCaptcha({
          geetest: {
            product: 'popup',
            lang: decodeURIComponent(util.getCookie('lang') || ''),
            width: '320px'
          },
          ready: function () {
            validateObj.captchaObj.onSuccess(function () {
              $('#captcha').parent().find('.error').removeClass('error');
            });
            switchType(me);
            $(me).data('clicking', false);
          }
        });
        validateObj.render();
      });
    } else {
      switchType(me);
    }
  });
  */

  var validateObj;

  function validateCaptcha(cb) {
    if (validateObj) {
      validateObj.captchaObj.reset();
      return cb();
    }
    validateObj = new window.EnhancerCaptcha({
      geetest: {
        product: 'popup',
        lang: decodeURIComponent(util.getCookie('lang') || ''),
        width: "320px"
      },
      ready: function() {
        validateObj.captchaObj.onSuccess(function() {
          $('#captcha').hide();
          getActiveCode()
        });
      }
    });
    validateObj.render();
    cb();
  }


  var getCodeTime;

  function getActiveCode () {
    var mobile = $('#account').val().trim();
    var isMobile = $('#register-type').val() === 'mobile';
    var exist = accountCache[mobile + 'mobile'] === 2;

    if (isMobile && util.isMobile(mobile) && !$('#account').hasClass('error') && !exist) {

      var data = validateObj.getValidate();
      if (!data) {
        return
      }
      data.mobile = mobile;

      util.getActiveCode($('#getActiveCode'), data, function () {
        $('.errortip').html(locale('help')).show();
      });
    } else {
      $('#account').focus();
    }
  }
  $('#getActiveCode').click(function (e) {
    e.preventDefault(); 

    var mobile = $('#account').val().trim();
    var isMobile = $('#register-type').val() === 'mobile';
    var exist = accountCache[mobile + 'mobile'] === 2;

    if (isMobile && util.isMobile(mobile) && !$('#account').hasClass('error') && !exist) {
      var now = (new Date).getTime();
      if (getCodeTime &&  now - getCodeTime < 59000) {
        return;
      } else {
        getCodeTime = now;
      }

      validateCaptcha(() => {
        $('#captcha').show();
      })
    } else {
      $('#account').focus();
    }    
  });

  $('.switch-lang').on('click', function() {
      var lang = util.getCookie('lang') || 'zh-cn';
      lang = lang === 'zh-cn' ? 'en' : 'zh-cn';
      util.setCookie('lang', lang, 3216672000000, domain, '/');
      window.location.reload(true);
  });

  var callbackUrl = util.getUrlParam('callbackUrl');


  if (callbackUrl) {
     var form = document.forms[0];
     form.setAttribute('action', '/register?callbackUrl=' + callbackUrl);

     $('.login a').each( function () {
         var url = $(this).prop('href');
         $(this).prop('href', url + '?callbackUrl=' + callbackUrl)
     });
  }

  var errorMsg = $('#error').text();
  if (errorMsg) {
    util.show(errorMsg, 'error')
  }

  
  $('body').append(captchaTip({
    locale: locale()
  }));
  $('.mobile-code-tip a').click(function (e) {
    e.preventDefault();
    $('.captcha-tip').show();
  });
  $('.captcha-tip .enhancer-close').click(function (e) {
    e.preventDefault();
    $('.captcha-tip').hide();
  });
}

init();
//setTimeout( init, 20);

window.handleEnhancerError = function (data) {
  if (data.stack.indexOf('https://api.geetest.com') != -1) {
    var type = $('#register-type').val();
    if (type === 'email'){
      $('.errortip').html(locale('help')).show();
    }
  }
}

util.setCookie('v', '1');

$('body').append('<div class="bg-des">Shot by zyz @Chefchaouen in February 2018</div>');




// WEBPACK FOOTER //
// ./src/pages/register/register.js